import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import Download from "../types/download";

interface DownloadState {
  downloads: Download[];
  status: "idle" | "loading" | "failed";
}

const initialState: DownloadState = {
  downloads: [],
  status: "idle",
};

export const getDownloads = createAsyncThunk<Download[]>(
  "download/fetch-all",
  async () => {
    const response = await http.get<Download[]>("/download");
    return response.data;
  }
);

const downloadSlice = createSlice({
  name: "download",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDownloads.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getDownloads.fulfilled, (state, action) => {
        state.status = "idle";
        state.downloads = action.payload;
      })
      .addCase(getDownloads.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default downloadSlice.reducer;
